module.exports = __webpack_public_path__ + "static/media/react midd.e9f621b3.pdf";